/**
 * Static fallbacks when KV has no published page (Phase 2K-Final).
 */
import { SACRED_PAGES_DEFAULTS } from "./sacred-pages-defaults";

export const PAGE_SLUGS = [
  "home",
  "knowledge-base",
  "archetypes",
  "karmic-gates",
  "adhikara-levels",
  "pathways",
  "prayer-hall",
  "sadhana",
  "satsanga",
  "acharya-ai",
  "dashboard-cards",
  "help-now",
  "about",
  "contact",
];

export const DEFAULT_SACRED_PAGES = SACRED_PAGES_DEFAULTS;

export function getDefaultSacredPage(slug) {
  const d = DEFAULT_SACRED_PAGES[slug];
  if (!d) {
    return {
      slug,
      title: slug.replace(/-/g, " "),
      sections: [{ id: "intro", type: "text", content: "", display: "block" }],
      metadata: {},
    };
  }
  return JSON.parse(JSON.stringify(d));
}

/** Map app paths to CMS slugs */
export const PATH_TO_PAGE_SLUG = {
  "/": "home",
  "/knowledge": "knowledge-base",
  "/knowledge-base": "knowledge-base",
  "/sadhana": "sadhana",
  "/prayer-hall": "prayer-hall",
  "/satsanga": "satsanga",
  "/guide": "acharya-ai",
  "/about": "about",
  "/contact": "contact",
  "/dashboard": "dashboard-cards",
  "/crisis": "help-now",
};
